import React from "react";
import Header from "./Components/Header";
import tutorsData from "./data/tutors.json";
import { Search, SlidersHorizontal } from "lucide-react";
import { useNavigate } from "react-router-dom";
import PageContainer from "./Components/PageContainer";
import MainContent from "./Components/MainContent";
import SectionTitle from "./Components/SectionTitle";
import TutorCard from "./Components/TutorCard";

const BookTutor = () => {
  const navigate = useNavigate();

  const handleTutorClick = () => {
    navigate("/classBooking/tutorDetails");
  };

  return (
    <PageContainer>
      <div className="sticky top-0 z-50 bg-[#DFF2EB]/70 backdrop-blur-md">
        <Header />
      </div>

      <MainContent>
        <SectionTitle 
          title="Find Your Perfect Tutor" 
          subtitle="Select year level to find qualified tutors" 
        />

        <div className="flex items-center gap-4 mt-6">
          <div className="relative w-full">
            <input
              type="text"
              placeholder="Search by tutor name or year"
              className="w-full px-12 py-3 rounded-xl border border-gray-200 shadow-sm focus:ring-2 focus:ring-blue-300 focus:outline-none"
            />
            <Search size={18} className="absolute left-4 top-3.5 text-gray-500" />
          </div>

          <button className="flex items-center gap-2 bg-white shadow-md px-6 py-3 rounded-xl border border-gray-200 text-gray-800">
            <SlidersHorizontal size={18} />
            Filters
          </button>
        </div>

        <p className="mt-6 text-gray-700 font-medium">
          Showing {tutorsData.length} tutors
        </p>

        <div className="grid grid-cols-2 gap-6 mt-6">
          {tutorsData.map((tutor, index) => (
            <TutorCard 
              key={tutor.id} 
              tutor={tutor} 
              onClick={handleTutorClick}
              isSelected={index === 1}
            />
          ))}
        </div>
      </MainContent>
    </PageContainer>
  );
};

export default BookTutor;
